export const GA_ADD_TO_CART = 'GA:addToCart';
export const GA_REMOVE_FROM_CART = 'GA:removeFromCart';
export const GA_CLICK_PRODUCT = 'GA:clickProduct';
export const GA_ADD_TO_SHOPPING_LIST = 'GA:addToShoppingList';
export const GA_REMOVE_FROM_SHOPPING_LIST = 'GA:removeFromShoppingList';
